module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-text-fill-92c80f89.svg";